export default "__VITE_ASSET__DTI4Ph8D__"